"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CallbackForm = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./style.css"));
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CallbackForm = _ref => {
  let {
    submitting,
    phone,
    personalAgreement,
    onClick,
    onChange,
    error
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: style['form']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['controls']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['input']
  }, /*#__PURE__*/React.createElement(_uiKit.MaskedInput, {
    disabled: submitting,
    mask: "(000) 000 00-00",
    leftAdornment: /*#__PURE__*/React.createElement(_uiKit.InputAdornment, null, "+7"),
    value: phone,
    onChange: onChange,
    invalid: error,
    size: "M",
    lazy: true
  })), /*#__PURE__*/React.createElement("div", {
    className: style['button']
  }, /*#__PURE__*/React.createElement(_uiKit.Button, {
    theme: "fill_white_primary",
    size: "M",
    color: "current_color",
    onClick: onClick,
    fullWidth: true,
    disabled: submitting
  }, "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"))), personalAgreement);
};
exports.CallbackForm = CallbackForm;